var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBligg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-concept",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bligg",
    transform: "translate(-294.000000, -14.000000)",
    fill: "#ABBFC6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Bliggit",
    transform: "translate(281.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0000204,12 C28.5228241,12 33,16.2533473 33,21.4999612 C33,26.1041998 29.5524021,29.9432262 24.9759821,30.8145748 L23.658754,32.6439632 C23.3172865,33.1186789 22.6827135,33.1186789 22.341246,32.6439632 L21.0250577,30.8147653 C16.448132,29.9437858 13,26.1045354 13,21.4999612 C13,16.2533473 17.4772168,12 23.0000204,12 Z M23.0000519,14 C18.5817283,14 14.9999387,17.357946 14.9999387,21.4999469 C14.9999387,25.6422132 18.5817283,29 23.0000519,29 C27.4183755,29 30.9999387,25.6422132 30.9999387,21.4999469 C30.9999387,17.357946 27.4183755,14 23.0000519,14 Z M25,18 C26.104598,18 27,18.8955614 27,20 C27,21.1045661 26.104598,22 25,22 C23.8954339,22 23,21.1045661 23,20 C23,18.8955614 23.8954339,18 25,18 Z",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBligg);
export default __webpack_public_path__ + "static/media/bligg.cd0e96382c13a8319fd7e8ecc2c4256e.svg";
export { ForwardRef as ReactComponent };